import { message, Modal } from 'antd';
import * as log from 'loglevel';
import { ReactNode } from 'react';
import './styles.css';

const { confirm, info, error } = Modal;

export const success = (msg: string): void => {
    message.success(msg);
};

export const apiErrorText = (msg: any): string => {
    if (typeof msg === 'string') {
        const trimmed = msg.trim();
        if (trimmed.charAt(0) === '{') {
            try {
                const parsed = JSON.parse(trimmed) as { error?: unknown };
                if (typeof parsed.error === 'string' && parsed.error.length > 0) {
                    return parsed.error;
                }
            } catch {
                // Response was not JSON. Show it as-is.
            }
        }
        return msg;
    }
    if (msg && typeof msg.message === 'string' && msg.message.length > 0) {
        return msg.message;
    }
    return 'Unknown error occured. Please contact developers.';
};

export const errorWithUserMessage = (msg: any): void => {
    if (!msg) {
        log.error('Bug with passing arguments, no message to be logged!');
    }
    log.error(msg);
    message.error(apiErrorText(msg), 8);
};

export const popupConfirmWithCallback = (
    callbackFunction: Function,
    callbackArguments?: any,
    message?: string,
    callbackOnCancel?: any,
    content?: ReactNode
): void => {
    confirm({
        title: message || 'Are you sure?',
        onOk(): void {
            callbackFunction(callbackArguments);
        },
        onCancel(): void {
            if (callbackOnCancel) {
                callbackOnCancel();
            }
        },
        content,
    });
};

export const popupConfirmDeleteWithCallback = (
    callbackFunction: Function,
    callbackArguments?: any,
    message?: string,
    confirmButtonText?: string,
    callbackOnCancel?: any,
    content?: ReactNode
): void => {
    confirm({
        title: message || 'Are you sure?',
        onOk(): void {
            callbackFunction(callbackArguments);
        },
        onCancel(): void {
            if (callbackOnCancel) {
                callbackOnCancel();
            }
        },
        okButtonProps: { danger: true, className: 'modal-delete-button' },
        okText: confirmButtonText || 'Delete',
        content,
    });
};

export const popupConfirm = (title: string): void => {
    info({
        title,
    });
};

export const popupError = (title: string): void => {
    error({
        title,
    });
};
